export default {
	//   sso_url:  'https://smusxath.bms.com/affwebservices/public/saml2sso?SPID=iwinv3p',
	sso_url: 'https://sso.bms.com/auth/saml2/jsp/idpSSOInit.jsp?metaAlias=/BMS/urn:bms:idp:115&spEntityID=iwinv3p'
}
